import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

export async function fetchClientPortalSettingsForOperator(locationId) {
    const qs = locationId ? `?location_id=${encodeURIComponent(locationId)}` : "";
    const res = await apiFetch(`${API_BASE}/client-portal/operator/settings${qs}`);
    if (!res.ok) throw new Error("Не вдалося завантажити налаштування сторінки клієнта");
    return res.json();
}

export async function saveClientPortalSettingsForOperator(payload) {
    const res = await apiFetch(`${API_BASE}/client-portal/operator/settings`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося зберегти налаштування");
    }
    return res.json();
}
